"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarCatalogAddComplictation = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var messageContext_1 = require("../../hoc/messageContext");
var selectors_1 = require("../../redux/selectors");
var catalogCarSlice_1 = require("../../redux/slice/catalogCarSlice");
var icons_1 = require("@ant-design/icons");
var form_1 = __importDefault(require("antd/es/form"));
var input_1 = __importDefault(require("antd/es/input"));
var button_1 = __importDefault(require("antd/es/button"));
var select_1 = __importDefault(require("antd/es/select"));
var input_number_1 = __importDefault(require("antd/es/input-number"));
var modal_1 = __importDefault(require("antd/es/modal"));
var tabs_1 = __importDefault(require("antd/es/tabs"));
var CarCatalogAddComplictation = function () {
    var catalogCar = (0, react_redux_1.useSelector)(selectors_1.catalogCarSelector).catalogCar;
    var _a = (0, react_1.useState)(undefined), packageGroup = _a[0], setPackageGroup = _a[1];
    var dispatch = (0, react_redux_1.useDispatch)();
    var id = (0, react_router_dom_1.useParams)().id;
    var _b = (0, messageContext_1.useMessageContext)(), showSuccess = _b.showSuccess, showError = _b.showError;
    var updateGroup = form_1.default.useForm()[0];
    var createGroup = form_1.default.useForm()[0];
    var _c = (0, react_1.useState)(false), isModalVisible = _c[0], setModalVisible = _c[1];
    var _d = (0, react_1.useState)(false), loading = _d[0], setLoading = _d[1];
    var handleAdd = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/car_catalog_configurations"), {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                car_catalog_configuration: __assign({ car_catalog_id: catalogCar === null || catalogCar === void 0 ? void 0 : catalogCar.id }, values),
                            }),
                        })];
                case 2:
                    response = _a.sent();
                    if (response.ok) {
                        dispatch((0, catalogCarSlice_1.catalogCarLoader)(id));
                        showSuccess('Данные успешно загружены');
                    }
                    else {
                        throw new Error('Ошибка при обновлении');
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    showError('Ошибка при обновлении данных');
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var items = [
        {
            key: '1',
            label: 'Добавить комплектацию в существующую группу',
            children: (react_1.default.createElement(form_1.default, { form: updateGroup, layout: "vertical", onFinish: handleAdd },
                react_1.default.createElement(form_1.default.Item, { name: "package_group", label: "\u041D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u0433\u0440\u0443\u043F\u043F\u044B", rules: [{ required: true, message: 'Необходимо выбрать группу по комплектации' }] },
                    react_1.default.createElement(select_1.default, { style: { backgroundColor: '#fff', color: 'rgba(0, 0, 0, 0.85)' }, placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0433\u0440\u0443\u043F\u043F\u0443 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u0438", value: packageGroup, onChange: function (value) { return setPackageGroup(value); }, options: catalogCar === null || catalogCar === void 0 ? void 0 : catalogCar.car_catalog_configurations.map(function (configuration) { return ({
                            label: configuration.package_group,
                            value: configuration.package_group,
                        }); }) })),
                react_1.default.createElement(form_1.default.Item, { label: "\u041A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u044F", name: "package_name", rules: [{ required: true, message: 'Наименование комплектации обязательно' }] },
                    react_1.default.createElement(input_1.default, { style: { backgroundColor: '#fff', color: 'rgba(0, 0, 0, 0.85)' } })),
                react_1.default.createElement(form_1.default.Item, { label: "\u041E\u0431\u044A\u0435\u043C", name: "volume" },
                    react_1.default.createElement(input_number_1.default, { step: 0.1, style: { width: '100%', backgroundColor: '#fff', color: 'rgba(0, 0, 0, 0.85)' } })),
                react_1.default.createElement(form_1.default.Item, { label: "\u041A\u041F\u041F", name: "transmission" },
                    react_1.default.createElement(input_1.default, { style: { backgroundColor: '#fff', color: 'rgba(0, 0, 0, 0.85)' } })),
                react_1.default.createElement(form_1.default.Item, { label: "\u041C\u043E\u0449\u043D\u043E\u0441\u0442\u044C", name: "power" },
                    react_1.default.createElement(input_number_1.default, { style: { width: '100%', backgroundColor: '#fff', color: 'rgba(0, 0, 0, 0.85)' } })),
                react_1.default.createElement(form_1.default.Item, { label: "\u0426\u0435\u043D\u0430", name: "price" },
                    react_1.default.createElement(input_number_1.default, { style: { width: '100%', backgroundColor: '#fff', color: 'rgba(0, 0, 0, 0.85)' } })),
                react_1.default.createElement(form_1.default.Item, { label: "\u0421\u043A\u0438\u0434\u043A\u0430 \u0437\u0430 \u043A\u0440\u0435\u0434\u0438\u0442, \u0440\u043E\u0441\u0441.\u0440\u0443\u0431", name: "credit_discount" },
                    react_1.default.createElement(input_number_1.default, { style: { width: '100%', backgroundColor: '#fff', color: 'rgba(0, 0, 0, 0.85)' } })),
                react_1.default.createElement(form_1.default.Item, { label: "\u0422\u0440\u0435\u0439\u0434-\u0438\u043D \u0441\u043A\u0438\u0434\u043A\u0430, \u0440\u043E\u0441\u0441.\u0440\u0443\u0431", name: "trade_in_discount" },
                    react_1.default.createElement(input_number_1.default, { style: { width: '100%', backgroundColor: '#fff', color: 'rgba(0, 0, 0, 0.85)' } })),
                react_1.default.createElement(form_1.default.Item, { label: "\u0421\u043A\u0438\u0434\u043A\u0430 \u0437\u0430 \u0443\u0442\u0438\u043B\u0438\u0437\u0430\u0446\u0438\u044E, \u0440\u043E\u0441\u0441.\u0440\u0443\u0431", name: "recycling_discount" },
                    react_1.default.createElement(input_number_1.default, { style: { width: '100%', backgroundColor: '#fff', color: 'rgba(0, 0, 0, 0.85)' } })),
                react_1.default.createElement(form_1.default.Item, { label: "\u0421\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u0430\u044F \u0446\u0435\u043D\u0430, \u0440\u043E\u0441\u0441.\u0440\u0443\u0431", name: "special_price" },
                    react_1.default.createElement(input_number_1.default, { style: { width: '100%', backgroundColor: '#fff', color: 'rgba(0, 0, 0, 0.85)' } })),
                react_1.default.createElement(form_1.default.Item, null,
                    react_1.default.createElement(button_1.default, { type: "primary", htmlType: "submit", loading: loading }, "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435")))),
        },
        {
            key: '2',
            label: 'Coздать новую группу',
            children: (react_1.default.createElement(form_1.default, { form: createGroup, layout: "vertical", onFinish: handleAdd },
                react_1.default.createElement(form_1.default.Item, { name: "package_group", label: "\u041D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u0433\u0440\u0443\u043F\u043F\u044B", rules: [{ required: true }] },
                    react_1.default.createElement(input_1.default, { style: { backgroundColor: '#fff', color: 'rgba(0, 0, 0, 0.85)' } })),
                react_1.default.createElement(form_1.default.Item, null,
                    react_1.default.createElement(button_1.default, { type: "primary", htmlType: "submit", loading: loading }, "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435")))),
        },
    ];
    var handleOpenModal = function () {
        setModalVisible(true);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, catalogCar ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(button_1.default, { type: "primary", icon: react_1.default.createElement(icons_1.PlusOutlined, null), onClick: handleOpenModal }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C"),
        react_1.default.createElement(modal_1.default, { title: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C", open: isModalVisible, onCancel: function () { return setModalVisible(false); }, footer: null },
            react_1.default.createElement(tabs_1.default, { defaultActiveKey: "1", items: items })))) : null));
};
exports.CarCatalogAddComplictation = CarCatalogAddComplictation;
